'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bezierEasing = require('bezier-easing');

var _bezierEasing2 = _interopRequireDefault(_bezierEasing);

var _animate = require('./animate');

var _animate2 = _interopRequireDefault(_animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var easeIn = (0, _bezierEasing2.default)(0, 0.3, 0.45, 1);

var enter = function enter(el) {
  var render = function render(percent) {
    el.style.opacity = percent;
    el.style.transform = 'translateX(' + (20 - 20 * percent) + 'px) translateZ(0)';
  };

  return (0, _animate2.default)(render, 750, easeIn);
};
var leave = function leave(bullets) {
  var render = function render(percent) {
    bullets.forEach(function (el) {
      el.style.opacity = 1 - percent;
    });
  };

  return (0, _animate2.default)(render, 500, easeIn);
};

var Loader = function (_Component) {
  (0, _inherits3.default)(Loader, _Component);

  function Loader() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Loader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.bullets = [], _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Loader.prototype.componentDidMount = function componentDidMount() {
    this.addBullet(0);
  };

  Loader.prototype.removeBullets = function removeBullets() {
    var _this2 = this;

    this.clearTimeout();
    this.timeout = setTimeout(function () {
      _this2.cancelLeave = leave(_this2.bullets);
      _this2.addBullet(0, 950);
    }, 1800);
  };

  Loader.prototype.addBullet = function addBullet(bullet) {
    var _this3 = this;

    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    this.clearTimeout();
    this.timeout = setTimeout(function () {
      _this3.cancelEnter = enter(_this3.bullets[bullet]);
      if (bullet < 2) {
        _this3.addBullet(++bullet);
      } else {
        _this3.removeBullets();
      }
    }, delay);
  };

  Loader.prototype.clearTimeout = function (_clearTimeout) {
    function clearTimeout() {
      return _clearTimeout.apply(this, arguments);
    }

    clearTimeout.toString = function () {
      return _clearTimeout.toString();
    };

    return clearTimeout;
  }(function () {
    this.timeout && clearTimeout(this.timeout);
  });

  Loader.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearTimeout();
    this.cancelEnter && this.cancelEnter();
    this.cancelLeave && this.cancelLeave();
  };

  Loader.prototype.render = function render() {
    var _this4 = this;

    return _react2.default.createElement(
      'div',
      { className: 'av-loading-indicator' },
      _react2.default.createElement(
        'span',
        { ref: function ref(c) {
            return _this4.bullets[0] = c;
          }, className: 'av-loading-bullet' },
        '\u2022'
      ),
      ' ',
      _react2.default.createElement(
        'span',
        { ref: function ref(c) {
            return _this4.bullets[1] = c;
          }, className: 'av-loading-bullet' },
        '\u2022'
      ),
      ' ',
      _react2.default.createElement(
        'span',
        { ref: function ref(c) {
            return _this4.bullets[2] = c;
          }, className: 'av-loading-bullet' },
        '\u2022'
      )
    );
  };

  return Loader;
}(_react.Component);

exports.default = Loader;


//////////////////
// WEBPACK FOOTER
// ./~/react-block-ui/lib/Loader.js
// module id = 146
// module chunks = 0